import React, { useEffect, useState } from 'react'
import { Button, Table, Select } from 'antd'
import type { ColumnsType } from 'antd/es/table'
import { ErrorMessages, retrieveData, useGetApiRequests } from '../../../../../../common/CommonExport'
import { useSelector, useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import axios, { AxiosResponse } from 'axios'
import DocumentPDFView from '../documents/documentPDFView'
import { setCertificateGeneratedReload } from '../../../../../../redux/slices/updateProfileSlice'
import ModalLoader from '../../../../../../components/Loader/ModalLoader'
import PopupModal from '../../modal/PopupModal'
import { useIsMobile } from '../../../../../../hooks/commonHooks'

import {
  ApiError,
  CertificateItem,
  ComponentState,

  DropDownOption,
  DueDataItem,
  EmployeeDeprovisionKV,
  EmployeeDocument,
  GenerateDocumentResponse,

  NoDueApprovalProps,

  ReasonsQueryParams,
  StatusItem,
  StatusListResponse,
  TemplateCategory
} from './types/NoDueApprovalTypes';


const NoDueApproval: React.FC<NoDueApprovalProps> = ({ noDueDetails }) => {
  const employeeDetails = useSelector((state: ComponentState) => state?.eventData?.particularEmployeeDetails);
  const reasonsList = useGetApiRequests('getResignationReasons', 'GET');
  const editNoDues = useGetApiRequests('editDeprovisionList', 'PUT');
  const dispatch = useDispatch();
  const { id } = useParams<{ id: string }>();
  const isMobile = useIsMobile();
  const userId = useSelector((state: ComponentState) => state?.userId?.id)
  const [loader, setLoader] = useState(true)
  const [dueData, setDueData] = useState<DueDataItem[]>([]);
  const [ApprovalData, setApprovalData] = useState<DueDataItem[]>([])
  const [certificateData, setCertificateData] = useState<CertificateItem[]>([])
  const [hilighted, setHilighted] = useState<boolean>(false)
  const [dropDownList, setDropDownList] = useState<DropDownOption[]>([])
  const [feedbackFormSubmit, setFeedbackFormSubmit] = useState(false)
  const [codes, setCodes] = useState<string[]>([])
  const [documentView, setDocumentView] = useState<boolean>(false)
  const [currentPdfDetails, setCurrentPdfDetails] = useState<CertificateItem | {}>({})
  const [statusData, setStatusData] = useState<StatusItem[]>([])
  const [modalerrMessage, setModalErrMessage] = useState('')
  const [popModal, setPopModal] = useState(false)
  const [modalResponse, setModalResponse] = useState('')
  const [modalButtonShow, setmodalButtonShow] = useState(true)

  useEffect(() => {
    setLoader(true);
    setFeedbackFormSubmit(noDueDetails?.isEmployeeExitInterviewFormSubmit)

    const newArray: DueDataItem[] = noDueDetails?.employeeDeprovisionKVDto?.map((item: EmployeeDeprovisionKV) => ({
      department: item.inchargeDescription,
      incharge: `${item.inchargeEmployee.firstName} ${item.inchargeEmployee.lastName}`,
      roleName: item?.inchargeDescription,
      inchargeEmployeeId: item?.inchargeEmployee.employeeId,
      employeeDeprovisionId: item?.employeeDeprovisionId,
      status: item?.status?.name,
      statusId: item?.status?.statusId
    })) || [];
    const filteredArray = newArray?.filter((item: DueDataItem) => item.department !== 'Employee');

    const certificates: CertificateItem[] = noDueDetails?.templateCategoryDto?.map((item: TemplateCategory) => {
      const matchingDocument = noDueDetails?.employeeDocument?.find((doc: EmployeeDocument) => doc?.document?.folderName === item?.name);
      const hasEmployeeSent = newArray?.some(
        (due: DueDataItem) => due?.department === "Employee" && due?.status === "Sent"
      );
      return {
        name: item?.name,
        code: item?.code,
        documentPath: matchingDocument ? matchingDocument?.documentPath : null,
        status: hasEmployeeSent && (item?.name === "No Due Certificate" || item?.name === "Exit Interview Form")
          ? "Sent"
          : "Pending",
        incharge: hasEmployeeSent && (item?.name === "No Due Certificate" || item?.name === "Exit Interview Form")
          ? "Sent"
          : matchingDocument ? "Sent" : "Not Sent"
      };
    }) || [];

    const codesFromApi = noDueDetails?.templateCategoryDto?.map((item: TemplateCategory) => item?.code) || []
    setCodes(codesFromApi)
    setCertificateData(certificates)
    setDueData(filteredArray)
    setApprovalData(newArray)
    getReasons();
    setLoader(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [noDueDetails])

  const getReasons = async () => {
    setLoader(true)
    const queryParams: ReasonsQueryParams = {
      statusCategory: 'Deprovision'
    }
    await reasonsList('', queryParams).then((res) => {
      console.log("res", res)
      const response = res as AxiosResponse<StatusListResponse>
      const statusList = response?.data?.data
      setStatusData(statusList)
      const list = statusList?.filter((item: StatusItem) => [36, 37].includes(item.statusId)) || []
      const reformedReasonList = list.map((item: StatusItem) => ({
        value: item?.statusId,
        label: item?.name
      }))
      setDropDownList(reformedReasonList);
      setLoader(false)

    })
      .catch(() => {
        setLoader(false)
      });
  }
  const handleChange = (record: DueDataItem, value: number, index: number) => {
    const shallowNoDueArray: DueDataItem[] = [...dueData];
    const pathParams = {
      id: `${record?.employeeDeprovisionId}/approval`
    }
    interface NoDueApprovalParams {
      employeeId: string | null;
      inchargeEmployeeId: string | number;
      statusId: number;
      roleName: string;
    }

    const queryParams: NoDueApprovalParams = {
      employeeId: retrieveData("employeeId", true),
      inchargeEmployeeId: record?.inchargeEmployeeId,
      statusId: value,
      roleName: record?.roleName.toString()
    }

    editNoDues(queryParams, {}, pathParams).then(() => {
      shallowNoDueArray[index].status = value ? 'Approved' : 'Pending'
      shallowNoDueArray[index].statusId = value;
      setDueData(shallowNoDueArray)
      setHilighted(true);
    })
      .catch((err: unknown) => {
        const error = err as ApiError;
        setPopModal(true)
        setmodalButtonShow(false)
        setModalErrMessage(error?.response?.data?.message ?? ErrorMessages.somethingWentWrong)
        setModalResponse('error')
        setTimeout(() => {
          handleClosePopUpModal();
          setLoader(false);
        }, 1500)
      })
  };
  const handleViewDocument = (details: CertificateItem) => {
    setCurrentPdfDetails(details)
    setDocumentView(true)
  }
  const matchedStatus = statusData.find((item: StatusItem) => item.name === employeeDetails?.resignationReason);
  const matchedStatusName = statusData.find((item: StatusItem) => item.name === 'Other');
  const matchStatusId = matchedStatus ? matchedStatus?.statusId : matchedStatusName?.statusId;

  const handleGenerate = () => {

    // if (allApproved) {
    setLoader(true);
    const filteredCodes = codes?.filter(code => code !== "EXIF");
    const queryString = filteredCodes?.map((code: string) => `templateCodeStringList=${code}`).join('&');
    const baseUrl: string = process.env.REACT_APP_BASEURL + `/hrm/employee/${id}/deprovision/document?userId=${userId}&statusId=${matchStatusId}&` + queryString
    axios.post(baseUrl)
      .then((res: AxiosResponse<GenerateDocumentResponse>) => {
        if (res.status === 200) {
          setFeedbackFormSubmit(false)
          dispatch(setCertificateGeneratedReload(true))
          if (res.data?.status?.message) {
            setPopModal(true)
            setmodalButtonShow(false)
            setModalErrMessage(res?.data?.status?.message)
            setModalResponse('success')
            setTimeout(() => {
              handleClosePopUpModal();
              setLoader(false);
              window.location.reload();
            }, 1500)
          }
        }
      })
      .catch((err: unknown) => {
        const error = err as ApiError;
        setPopModal(true)
        setmodalButtonShow(false)
        setModalErrMessage(error?.response?.data?.message ?? ErrorMessages.somethingWentWrong)
        setModalResponse('error')
        setTimeout(() => {
          handleClosePopUpModal();
          setLoader(false);
        }, 1500)
      })
    // } else {
    //   triggerNotification('error', '', ErrorMessages?.deprovisionGenerate, 'topRight')
    // }
  }
  const handleClosePopUpModal = () => {
    setPopModal(false)
  }
  const columns: ColumnsType<DueDataItem> = [
    {
      title: 'Departments',
      dataIndex: 'department',
      key: 'department',
      width: "35%"
    },
    {
      title: 'Person InCharge',
      dataIndex: 'incharge',
      key: 'incharge',
      width: "30%"

    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      width: "20%",
      render: (text: string, record: DueDataItem, index: number) => (
        <div className={`${record?.status !== 'Sent' ? 'cursor-default pointer-events-none' : 'cursor-pointer pointer-events-auto'}`}>
          <div className='justify-center _status items-center py-2 ' >
            <Select
              className={hilighted ? "hilighted" : ""}
              style={{ width: 120 }}
              value={record?.status}
              onChange={(value: string | number) => handleChange(record, value as number, index)}
              suffixIcon={<span className="material-symbols-outlined"> expand_more</span>}
              options={dropDownList}
              disabled={record?.status === 'Sent'}>

            </Select>
          </div>
        </div>
      ),
    },
  ];

  const columnsDocument: ColumnsType<CertificateItem> = [
    {
      title: 'Document',
      dataIndex: 'name',
      key: 'name',
      width: "45%"
    },
    {
      title: 'Status',
      dataIndex: 'incharge',
      key: 'incharge',
      width: "35%",
      render: (text: string, record: CertificateItem) => (
        <div className={`${record.documentPath ? 'text-black' : ' text-gray-500 '}`}>
          {!record.documentPath ? <p>{text}</p> : <p>Completed</p>}
        </div>),
    },

    {
      title: 'Preview',
      dataIndex: 'status',
      key: 'status',
      width: "10%",
      render: (text: string, record: CertificateItem) => (
        <div
          className={`deprovision_visiblity_parent ${isMobile
            ? 'pointer-events-none text-gray-400'
            : record.documentPath
              ? 'cursor-pointer'
              : 'cursor-not-allowed pointer-events-none text-gray-400'
            }`}
        >

          <div onClick={() => handleViewDocument(record)} className='justify-center items-center py-2 pl-4' >
            <span
              className={`material-symbols-outlined deprovision_visiblity ${isMobile
                ? 'pointer-events-none text-gray-400'
                : record.documentPath
                  ? 'cursor-pointer'
                  : 'pointer-events-none text-gray-400'
                }`}
            >
              visibility
            </span>

          </div>
        </div>),

    },
  ];

  const filteredDueData = ApprovalData?.filter((item: DueDataItem) => item?.department !== "Employee");
  const isAllApproved = filteredDueData?.every((item: DueDataItem) => item?.status === "Approved");
  const getDisable = () => {
    if (isMobile) {
      return true;
    }
    const isSent = certificateData?.some(
      (data: CertificateItem) => data?.name === "Relieving Letter" && data?.incharge === "Sent"
    );
    if (!isAllApproved || !feedbackFormSubmit || isSent) {
      return true;
    }
    return false;
  };

  return (
    <div className="flex w-full justify-between pt-10  asset-collection-box">
      <div className="w-[45%] box-row">
        <h3 className='text-[#D34A7C] text-[15px] font-semibold pb-[10px]'>NO DUE APPROVAL</h3>
        {loader && <ModalLoader />}
        <Table dataSource={dueData} columns={columns} pagination={false} scroll={{ x: true }} />
      </div>
      <div className="w-[45%] box-row  asset-collection ">
        <div className="flex w-full justify-between">
          <h3 className='text-[#D34A7C] text-[15px] font-semibold'>DOCUMENTS</h3>
          <Button type="primary"
            disabled={
              getDisable()
            }
            onClick={handleGenerate}>Generate</Button>
        </div>
        <Table dataSource={certificateData} columns={columnsDocument} pagination={false} />
      </div>
      {documentView && <DocumentPDFView open={documentView} setDocumentView={setDocumentView} currentPdfDetails={currentPdfDetails} certificate={true} mainPage={false} />}
      {popModal && <PopupModal message={modalerrMessage} open={popModal} handleModalClose={handleClosePopUpModal} response={modalResponse} modalButtonShow={modalButtonShow} />}
    </div>
  )
}

export default NoDueApproval